import React from "react";
import { Container, Header, Divider, Image } from "semantic-ui-react";

const imageList = [
  {
    label: "Annotating document on the fly",
    src:
      "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/alex%2Fannotate.gif?alt=media&token=7452ee0c-dad5-4ce1-ab4d-2d1c0c5e221a"
  },
  {
    label: "Spatial capturing of annotated coordinates",
    src:
      "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/alex%2Fannotated_data.gif?alt=media&token=36ffbb0c-028a-4d98-aef4-8ddd2b904a46"
  },
  {
    label: "Recursive data traversal on document models",
    src:
      "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/alex%2Fdata_traversal.gif?alt=media&token=b0872b79-4061-4d35-b426-3c836c073173"
  },
  {
    label: "Generating documents with ML",
    src:
      "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/alex%2Fdoc_generation.gif?alt=media&token=3d5eab4e-b146-4938-8408-c82b8a5241a0"
  }
];
export const alex = () => {
  return (
    <Container>
      <Divider hidden />
      <Header as="h1">
        <Header.Content>Alex</Header.Content>
        <Header.Subheader>
          <p>
            A platform to train and automate document generation for Logistic
            Industry. Which eventually reduces human error and make{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://en.wikipedia.org/wiki/Freight_forwarder"
            >
              Freight Forwarders
            </a>{" "}
            more efficient.
          </p>
          <p>
            Credit : Designed and co-developed with{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/siddharthsahani/"
            >
              @Siddharth
            </a>
            ,{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/in/vimoxshah/"
            >
              @Vimox
            </a>
          </p>
        </Header.Subheader>
      </Header>
      <Divider />
      <Image.Group size="large">
        {imageList.map((image, i) => {
          return (
            <Image
              key={i}
              rounded
              verticalAlign="top"
              src={image.src}
              label={image.label}
            />
          );
        })}
      </Image.Group>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/Projects/alex.js